function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 17.438V.563a.562.562 0 1 1 1.125 0v16.875a.562.562 0 1 1-1.125 0zM9.563 5.066a.56.56 0 0 1-.556.558H2.806a.56.56 0 0 1-.556-.558V2.808a.56.56 0 0 1 .556-.558h6.2a.56.56 0 0 1 .556.558v2.259zm4.5 10.125a.56.56 0 0 1-.556.558H2.806a.56.56 0 0 1-.556-.558v-2.259a.56.56 0 0 1 .556-.558h10.7a.56.56 0 0 1 .556.558v2.259zM18 10.129a.56.56 0 0 1-.556.559H2.806a.56.56 0 0 1-.556-.559V7.871a.56.56 0 0 1 .556-.559h14.638a.56.56 0 0 1 .556.559v2.258z",
  id: "chart-bar-horizontal"
});

var SvgChartBarHorizontal = function SvgChartBarHorizontal(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    width: "1.285714285714286rem",
    height: "1.285714285714286rem",
    fill: "currentColor",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChartBarHorizontal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chart-bar-horizontal.f384aeda.svg";
export { ForwardRef as ReactComponent };